import { storageRef } from "../../config/firebaseInitial";
import { updateUserCollectionImgUrl } from "./userProfileActions";

export const storeUserImage = file => dispatch => {
  if (file) {
    var img = new Image();

    img.src = window.URL.createObjectURL(file);

    img.onload = function () {
      var width = img.naturalWidth,
        height = img.naturalHeight;

      window.URL.revokeObjectURL(img.src);

      if (width < 600 && height < 600) {
        let uploadTask = storageRef.child("useImages/" + file.name).put(file);
        checkUploadTask(uploadTask, dispatch);
      } else {
        alert("حجم الصورة غير مناسب ,يجب ان يكون كلا البعدين اقل من 600");
      }
    };
  }
};

const checkUploadTask = (uploadTask, dispatch) => {
  uploadTask.on(
    "state_changed",
    function (snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    },
    function (error) {

    },
    function () {
      uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
        dispatch(updateUserCollectionImgUrl(downloadURL));
      });
    }
  );
};


